module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/SPG.93d23cc1.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/SPG.png
// module id = 2716
// module chunks = 11